const privacybeleid = {
  seo: {
    title: "Privacybeleid | Ramen Repair Eindhoven",
    description: "Hoe Ramen Repair Eindhoven uw persoonsgegevens verwerkt conform de AVG. Lees welke data wij verzamelen, waarvoor en uw rechten.",
    h1: "Privacybeleid",
  },
  version: "Versie 1.0 — Laatst bijgewerkt: 28 mei 2026",
  sections: [
    {
      nr: "1",
      title: "Verwerkingsverantwoordelijke",
      paragraphs: [
        "Ramen Repair Eindhoven, gevestigd te Eindhoven, is verwerkingsverantwoordelijke in de zin van de Algemene Verordening Gegevensbescherming (AVG, Verordening EU 2016/679). Dit privacybeleid is van toepassing op alle verwerkingen van persoonsgegevens door Ramen Repair Eindhoven.",
      ],
      list: [
        "Bedrijfsnaam: Ramen Repair Eindhoven",
        "KvK-nummer: 89234567",
        "BTW-nummer: NL001234567B01",
        "Adres: Marconilaan 3, 5612 HM Eindhoven",
        "Telefoon: 040 798 7470",
        "E-mail: info@ramen-repair-eindhoven.nl",
        "Privacycontact: privacy@ramen-repair-eindhoven.nl",
      ],
    },
    {
      nr: "2",
      title: "Welke gegevens wij verzamelen",
      paragraphs: [
        "Wij verwerken uitsluitend persoonsgegevens die noodzakelijk zijn voor het uitvoeren van onze diensten en het voldoen aan wettelijke verplichtingen. De gegevens die wij verzamelen, zijn afhankelijk van de wijze waarop u met ons in contact treedt.",
      ],
      list: [
        "NAW-gegevens (naam, adres, woonplaats) bij offerte-aanvragen en facturatie",
        "Contactgegevens (telefoonnummer, e-mailadres) voor communicatie en afspraken",
        "IP-adres en browsergegevens door middel van cookies en analyse-tools",
        "Inhoud van offerte-aanvragen, correspondentie en opmerkingen bij opdrachten",
        "Bankgegevens (rekeningnummer) bij betaling per automatische incasso",
        "Foto's of bijlagen die u meestuurt bij een offerte-aanvraag",
      ],
    },
    {
      nr: "3",
      title: "Doeleinden van verwerking",
      paragraphs: [
        "Wij verwerken persoonsgegevens uitsluitend voor specifieke, uitdrukkelijk omschreven doeleinden. Gegevens worden niet voor andere doeleinden gebruikt dan waarvoor zij zijn verzameld.",
      ],
      list: [
        "Uitvoering van de overeenkomst: het leveren van reparatie-, onderhouds- en vervangingsdiensten, facturatie en betaling",
        "Klantenservice en communicatie: het beantwoorden van vragen, afspraken plannen en het verstrekken van garantie-informatie",
        "Wettelijke verplichtingen: het voldoen aan fiscale en administratieve bewaarplichten, waaronder de bewaarplicht voor boekhouding en belastingheffing",
        "Website-analyse en verbetering: het analyseren van bezoekersgedrag om onze website te optimaliseren",
        "Marketing en communicatie: uitsluitend na expliciete toestemming (opt-in) voor nieuwsbrieven en promoties",
      ],
    },
    {
      nr: "4",
      title: "Wettelijke grondslagen",
      paragraphs: [
        "Wij verwerken persoonsgegevens op basis van de volgende wettelijke grondslagen uit de AVG. Voor elke verwerking leggen wij vast op welke grondslag deze berust.",
      ],
      list: [
        "Uitvoering overeenkomst (artikel 6 lid 1 onder b AVG): verwerking van klantgegevens die noodzakelijk zijn voor het sluiten en uitvoeren van een overeenkomst",
        "Wettelijke verplichting (artikel 6 lid 1 onder c AVG): bewaarplicht van financiële administratie en klachtendossiers",
        "Toestemming (artikel 6 lid 1 onder a AVG): verzending van nieuwsbrieven en plaatsing van niet-noodzakelijke cookies",
        "Gerechtvaardigd belang (artikel 6 lid 1 onder f AVG): fraudepreventie, beveiliging van IT-systemen en anonieme statistieken",
      ],
    },
    {
      nr: "5",
      title: "Bewaartermijnen",
      paragraphs: [
        "Wij bewaren persoonsgegevens niet langer dan noodzakelijk voor het doel waarvoor zij zijn verzameld, dan wel voor zolang de wet een bewaarplicht oplegt. Na afloop van de bewaartermijn worden gegevens vernietigd of geanonimiseerd.",
      ],
      list: [
        "Klantgegevens en facturen: 7 jaar (fiscale bewaarplicht Wet op de Omzetbelasting en wetgeving op het gebied van boekhouding)",
        "Offerte-aanvragen zonder vervolg: 1 jaar, daarna vernietigd",
        "Correspondentie en klachtendossiers: 2 jaar na afhandeling",
        "Marketing-toestemming en nieuwsbriefinschrijvingen: tot intrekking van toestemming (opt-out)",
        "Sollicitatiegegevens: 4 weken na afwijzing, tenzij u toestemming geeft voor langere bewaring",
        "Analytische cookies: 14 maanden, daarna automatisch verwijderd",
      ],
    },
    {
      nr: "6",
      title: "Delen met derden",
      paragraphs: [
        "Wij verkopen, verhuren of verhandelen uw persoonsgegevens niet aan derden. Persoonsgegevens worden uitsluitend gedeeld met derden indien dit noodzakelijk is voor de uitvoering van onze diensten of indien wij daartoe wettelijk verplicht zijn.",
      ],
      list: [
        "Onderaannemers en verwerkers: boekhouder, hostingpartij en e-mailprovider, allen gebonden door een getekende verwerkersovereenkomst (artikel 28 AVG)",
        "Betalingsdienstverleners: banken en betaalproviders voor het afhandelen van transacties",
        "Overheidsinstanties: bij wettelijke verplichting, waaronder de Belastingdienst en justitie",
        "Verzekeringsmaatschappijen: uitsluitend bij inbraakschadereparaties met uw expliciete toestemming",
        "Wij verkopen GEEN persoonsgegevens aan derden voor commerciële doeleinden",
      ],
    },
    {
      nr: "7",
      title: "Cookies",
      paragraphs: [
        "Wij maken gebruik van cookies om onze website te laten functioneren en om inzicht te krijgen in het gebruik van onze website. Cookies zijn kleine tekstbestanden die door uw browser worden opgeslagen.",
        "Functionele cookies zijn noodzakelijk voor de werking van de website en worden zonder toestemming geplaatst. Analytische en marketingcookies worden pas geplaatst nadat u hier expliciet toestemming voor heeft gegeven via onze cookiebanner.",
      ],
      links: [
        {
          text: "Bekijk ons volledige cookiebeleid",
          url: "/cookiebeleid/",
        },
      ],
    },
    {
      nr: "8",
      title: "Beveiliging van gegevens",
      paragraphs: [
        "Ramen Repair Eindhoven treft passende technische en organisatorische maatregelen om persoonsgegevens te beschermen tegen verlies, onrechtmatige verwerking of ongeautoriseerde toegang. Deze maatregelen worden periodiek geëvalueerd en aangepast.",
      ],
      list: [
        "SSL/TLS-encryptie van alle dataoverdracht tussen uw browser en onze server",
        "Versleutelde opslag van persoonsgegevens en facturen op beveiligde servers",
        "Toegangscontrole: persoonsgegevens zijn alleen toegankelijk voor geautoriseerd personeel",
        "Periodieke security-audits en updates van onze systemen en software",
        "Bij een datalek melden wij dit binnen 72 uur bij de Autoriteit Persoonsgegevens, en indien van toepassing ook bij u persoonlijk",
      ],
    },
    {
      nr: "9",
      title: "Uw rechten onder de AVG",
      paragraphs: [
        "Als betrokkene heeft u de volgende rechten met betrekking tot uw persoonsgegevens. Deze rechten kunt u uitoefenen door contact op te nemen met ons privacycontact.",
      ],
      list: [
        "Recht op inzage (artikel 15 AVG): u heeft het recht te weten welke gegevens van u worden verwerkt",
        "Recht op rectificatie (artikel 16 AVG): u kunt onjuiste gegevens laten corrigeren of aanvullen",
        "Recht op verwijdering / vergetelheid (artikel 17 AVG): u kunt verzoeken om verwijdering van uw gegevens, tenzij wij een wettelijke bewaarplicht hebben",
        "Recht op beperking van verwerking (artikel 18 AVG): u kunt verzoeken om beperking van verwerking bij een geschil over juistheid of rechtmatigheid",
        "Recht op dataportabiliteit (artikel 20 AVG): u kunt verzoeken om uw gegevens in een gestructureerd, gangbaar formaat te ontvangen",
        "Recht van bezwaar (artikel 21 AVG): u kunt bezwaar maken tegen verwerking op basis van gerechtvaardigd belang",
        "Recht om toestemming in te trekken: u kunt te allen tijde uw toestemming voor marketing of cookies intrekken",
      ],
    },
    {
      nr: "10",
      title: "Hoe rechten uitoefenen",
      paragraphs: [
        "U kunt een verzoek tot uitoefening van uw rechten indienen door een e-mail te sturen naar privacy@ramen-repair-eindhoven.nl. Om misbruik te voorkomen, vragen wij u bij een verzoek tot inzage een kopie van uw identiteitsbewijs mee te sturen. Zet hiervoor een zwarte streep door uw burgerservicenummer (BSN) en pasfoto.",
        "Wij reageren binnen vier (4) weken op uw verzoek. Indien het verzoek complex is of wij meerdere verzoeken van u hebben ontvangen, kunnen wij deze termijn met twee (2) maanden verlengen. Wij informeren u hierover binnen vier weken na ontvangst van het verzoek.",
      ],
    },
    {
      nr: "11",
      title: "Klacht indienen bij de Autoriteit Persoonsgegevens",
      paragraphs: [
        "Indien u van mening bent dat Ramen Repair Eindhoven uw persoonsgegevens niet juist of rechtmatig verwerkt, heeft u het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens (AP). Wij verzoeken u echter om eerst contact met ons op te nemen, zodat wij gezamenlijk naar een oplossing kunnen zoeken.",
      ],
      links: [
        {
          text: "Autoriteit Persoonsgegevens",
          url: "https://www.autoriteitpersoonsgegevens.nl",
        },
      ],
    },
    {
      nr: "12",
      title: "Wijzigingen privacybeleid",
      paragraphs: [
        "Wij behouden ons het recht voor om dit privacybeleid te wijzigen. Wijzigingen worden met ingang van de in het beleid genoemde datum van kracht. Substantiële wijzigingen die invloed hebben op de wijze waarop wij uw gegevens verwerken, worden gecommuniceerd via onze website en per e-mail indien wij uw e-mailadres in bezit hebben.",
        "Wij raden u aan dit privacybeleid regelmatig te raadplegen, zodat u op de hoogte blijft van de meest actuele versie.",
      ],
    },
    {
      nr: "13",
      title: "Contact",
      paragraphs: [
        "Heeft u vragen over dit privacybeleid of over de wijze waarop wij omgaan met uw persoonsgegevens? Neem dan contact met ons op via onderstaande gegevens.",
      ],
      list: [
        "Privacy-vragen: privacy@ramen-repair-eindhoven.nl",
        "Telefoon: 040 798 7470",
        "Post: Marconilaan 3, 5612 HM Eindhoven",
        "Wij zijn bereikbaar van maandag tot zondag, 08:00 tot 20:00 uur.",
      ],
    },
  ],
  footer: {
    version: "Laatst bijgewerkt: 28 mei 2026. Versie 1.0.",
  },
};

export default privacybeleid;